import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class UntiBar extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getUnitList(params) {
    return this.httpService.get("Project/list-unit-designer-with-image", {
      headers,
      params,
    });
  }

  getRebuildUnit(params) {
    return this.httpService.get("Project/rebuild-unit", { headers, params });
  }

  deleteUnitArray(data) {
    return this.httpService.delete("Project/remove-units", { headers, data });
  }

  deleteUnit(data) {
    return this.httpService.delete("Project/remove-unit", { headers, data });
  }

  updateUnit(data) {
    return this.httpService.put("Project/info-unit", data, { headers });
  }

  ConvertUnitAction(data) {
    return this.httpService.put("Project/convert-unit", data, { headers });
  }

  CopyUnitAction(data) {
    return this.httpService.post("Project/copy-unit", data, { headers });
  }
}

const UntiBarService = new UntiBar();
export default UntiBarService;
